import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const ShopContext = createContext(null);

export const ShopProvider = ({ children }) => {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], subtotal: 0, shipping: 0, total: 0 });
  const [wishlist, setWishlist] = useState({ product_ids: [], products: [] });

  const refreshCart = useCallback(async () => {
    if (!user) { setCart({ items: [], subtotal: 0, shipping: 0, total: 0 }); return; }
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } catch {/* ignore */}
  }, [user]);

  const refreshWishlist = useCallback(async () => {
    if (!user) { setWishlist({ product_ids: [], products: [] }); return; }
    try {
      const { data } = await api.get("/wishlist");
      setWishlist(data);
    } catch {/* ignore */}
  }, [user]);

  useEffect(() => { refreshCart(); refreshWishlist(); }, [refreshCart, refreshWishlist]);

  const addToCart = async (product_id, qty = 1, variant_sku = null) => {
    const { data } = await api.post("/cart/add", { product_id, qty, variant_sku });
    setCart(data);
    return data;
  };
  const updateCart = async (product_id, qty, variant_sku = null) => {
    const { data } = await api.post("/cart/update", { product_id, qty, variant_sku });
    setCart(data);
  };
  const removeCart = async (product_id, variant_sku = null) => {
    const { data } = await api.post("/cart/remove", { product_id, variant_sku });
    setCart(data);
  };
  const clearCart = async () => {
    const { data } = await api.post("/cart/clear");
    setCart(data);
  };
  const toggleWishlist = async (product_id) => {
    const { data } = await api.post("/wishlist/toggle", { product_id });
    setWishlist((w) => ({ ...w, product_ids: data.product_ids }));
    await refreshWishlist();
    return data.in_wishlist;
  };
  const isWishlisted = (pid) => wishlist.product_ids?.includes(pid);

  return (
    <ShopContext.Provider value={{
      cart, wishlist, addToCart, updateCart, removeCart, clearCart,
      toggleWishlist, isWishlisted, refreshCart, refreshWishlist,
    }}>
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
